/**
 * Statut d'un cours, lisible d'un coup d'œil.
 *
 * La couleur ne porte pas seule l'information : le libellé est toujours présent
 * et traduit. Une pastille de couleur nue serait invisible pour qui ne
 * distingue pas les teintes, et illisible en niveaux de gris.
 */
import { useTranslation } from "react-i18next";

import { cn } from "@/shared/lib/cn";

const TONES: Record<string, string> = {
  draft: "bg-slate-100 text-slate-700 dark:bg-slate-800 dark:text-slate-300",
  published: "bg-emerald-100 text-emerald-800 dark:bg-emerald-900/40 dark:text-emerald-300",
  archived: "bg-amber-100 text-amber-800 dark:bg-amber-900/40 dark:text-amber-300",
};

export function StatusBadge({ status }: { status: string }) {
  const { t } = useTranslation("catalog");

  return (
    <span
      className={cn(
        "inline-flex shrink-0 items-center rounded-full px-2 py-0.5 text-xs font-medium",
        TONES[status] ?? TONES["draft"],
      )}
    >
      {t(`status.${status}`)}
    </span>
  );
}
